<template>
  <div>
    <px-view-header title="Centro de Custo" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-centro-custo-list-header :on-click-refresh="onClickRefresh"
                                 :on-change-filter="onChangeFilter" />
    <px-centro-custo-list :centros-custo="centrosCusto"
                          :loading="loading"
                          :on-change-options="onChangeOptions"
                          :options-list="optionsList"
                          :footer-options="footerOptions"
                          @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-centro-custo/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import CentroCustoService from './centro-custo-service';
import CentroCustoList from './CentroCustoList.vue';
import CentroCustoListHeader from './CentroCustoListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Centros de custo' },
      ],
      centrosCusto: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCentroCusto', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemCentroCusto', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getCentroCusto();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getCentroCusto();
    },
    onClickRefresh() {
      this.getCentroCusto();
    },
    onRemove(item) {
      this.loading = true;
      CentroCustoService.remover(item.id)
        .then(() => {
          this.$toast('Centro de custo removido com sucesso', { color: 'success' });
          this.getCentroCusto();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCentroCusto() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CentroCustoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.centrosCusto = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxCentroCustoList: CentroCustoList,
    pxCentroCustoListHeader: CentroCustoListHeader,
  },
};

</script>
